import React, {Component} from 'react';
import HeaderSectionComponent from '../HeaderSectionComponent/HeaderSectionComponent';
import TandCComponent from '../TandCComponent/TandCComponent';
import CalloutCardComponent from '../CalloutCardComponent/CalloutCardComponent';
import ChangePasswordComponent from '../ChangePasswordComponent/ChangePasswordComponent';

class ChangePasswordPageComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: '',
            errorTitle: ''
        };
        this.handleError = this.handleError.bind(this);
        this.clearAlert = this.clearAlert.bind(this);
    }

    clearAlert() {
        this.setState({error: '', errorTitle: ''});
    }

    handleError(error) {
        this.setState({error});
    }

    render() {
        let options = {'siteName': this.props.siteName};
        let cardContent = (
            <ChangePasswordComponent
                actionLocation={this.props.actionLocation}
                lingua={this.props.lingua}
                service={this.props.service}
                handleError={this.handleError}
                site={this.props.site}
                updatePage={this.props.updatePage}
                ticketId={this.props.ticketId}
                isWaiting={this.props.isWaiting}
                enableLoading={this.props.enableLoading}
                disableLoading={this.props.disableLoading}
            />
        );
        return (
            <div className="ChangePasswordPageComponent border-border-color">
                <HeaderSectionComponent header={this.props.lingua.read('lex.header.password', options)}/>
                <CalloutCardComponent content = {cardContent} error={this.state.error} errorTitle={this.state.errorTitle} clearAlert={this.clearAlert}/>
                <TandCComponent lingua={this.props.lingua} multiUserEnabled={this.props.multiUserEnabled}/>
            </div>
        );
    }
}

export default ChangePasswordPageComponent;
